/**
 * @fileoverview POST handler for the "/companies/:company_id/sender_verification/sending_domains" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdSenderVerificationSendingDomainsCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdSenderVerificationSendingDomainsProps,
  SenderVerificationSendingDomainsPostResult,
} from "./types";

export const postCompaniesCompanyIdSenderVerificationSendingDomains = reactQueryMutationAdapter(
  companiesCompanyIdSenderVerificationSendingDomainsCacheKeys,
  (
    props: PostCompaniesCompanyIdSenderVerificationSendingDomainsProps
  ): Promise<SenderVerificationSendingDomainsPostResult> => {
    // manipulate props here as needed {  }

    return fetch(
      `/companies/${props.company_id}/sender_verification/sending_domains`,
      "POST",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
